export const cardDetails = {
    CREDIT: {
        MAIN: { fields: ['availableCredit', 'authorizedAmount', 'limit'] },
        BUSINESS: { fields: ['availableCredit', 'authorizedAmount', 'limit'] },
    },
    PREPAID: {
        PREPAID: { fields: ['availableAmount'] },
    },
};
